import React from 'react';
import { Card, Statistic, Progress, Tooltip, Empty } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

function ReportesEntregadosTile({ data, loading }) {
  if (loading) return <Card title="Reportes entregados" loading />;
  if (!data) {
    return (
      <Card title="Reportes entregados">
        <Empty description="Sin datos" />
      </Card>
    );
  }

  const { total_cerradas, con_email, pct } = data;
  const color = pct >= 90 ? '#52c41a' : pct >= 75 ? '#faad14' : '#f5222d';

  return (
    <Card
      title={
        <span>
          Reportes entregados{' '}
          <Tooltip title="% mantenciones cerradas cuyo cliente tiene email configurado. El resto cae al mail interno de Prolift como fallback silencioso.">
            <InfoCircleOutlined style={{ color: '#8c8c8c' }} />
          </Tooltip>
        </span>
      }
    >
      <Statistic
        value={pct}
        suffix="%"
        valueStyle={{ color, fontSize: '2rem' }}
      />
      <Progress percent={pct} strokeColor={color} showInfo={false} />
      <div style={{ color: '#8c8c8c', fontSize: 12, marginTop: 8 }}>
        {con_email} de {total_cerradas} mantenciones cerradas este mes
      </div>
    </Card>
  );
}

export default ReportesEntregadosTile;
